import { workloadStatusesEnum } from "helpers/enums";
import React, { useEffect } from "react";
import SignalRConnection from "services/signalRConnection";
import Action from "./action";
import Status from "./status";

const BgTask = (props) => {
    const { status, key, title } = props.item;

    useEffect(() => {
        if (![workloadStatusesEnum.NotStarted, workloadStatusesEnum.Running].includes(status)) {
            return;
        }

        const connection = new SignalRConnection({
            url: "/signalr/syncWorks",
            connectionParams: key,
            actions: [
                {
                    name: "SetStatus",
                    action: (newStatus) => {
                        props.updateItem({ key, data: { status: newStatus } });
                    },
                },
            ],
            joinActionName: "Subscribe",
            leaveActionName: "Unsubscribe",
        });

        return () => {
            connection.disconnect();
        };
    }, [status, key, props.updateItem]);

    return (
        <div className="bg-task">
            <div className="bg-task__title">{title}</div>
            <div className="bg-task__actions">
                {[workloadStatusesEnum.Completed, workloadStatusesEnum.Faulted].includes(status) && (
                    <Action
                        {...props.item}
                        taskKey={key}
                        history={props.history}
                        location={props.location}
                        removeItem={props.removeItem}
                    />
                )}
                <Status status={status} />
            </div>
        </div>
    );
};

export default BgTask;
